import './theme/index.css';
import './assets/fonts/fonts.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import { memo, useEffect } from 'react';
import { Router } from './Router';
import { initPostHog, posthog } from 'utils/posthog/posthogClient';
import type { Properties } from 'posthog-js';

initPostHog();

declare global {
  interface Window {
    posthog: typeof posthog;
    phCapture: (name: string, props?: Properties) => void;
  }
}

if (typeof window !== 'undefined') {
  window.posthog = posthog;
  window.phCapture = (name: string, props?: Properties) => {
    try {
      posthog.capture(name, props);
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error('[phCapture] posthog.capture failed:', e);
      }
    }
  };
}

const PostHogCleanup = () => {
  useEffect(() => {
    const handleUnload = () => {
      try {
        posthog.capture('$pageleave');
      } catch {
        /* ignore */
      }
    };

    window.addEventListener('pagehide', handleUnload);
    return () => window.removeEventListener('pagehide', handleUnload);
  }, []);

  return null;
};

export const App = memo(() => (
  <>
    <PostHogCleanup />
    <Router />
  </>
));
